import { getCurrentLocaleCode } from "@mongez/localization";
import { Link as RemixLink } from "@remix-run/react";
import { type RemixLinkProps } from "@remix-run/react/dist/components";

type LinkProps = {
  to: string;
} & RemixLinkProps;

const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

export function Link({ to, ...props }: LinkProps) {
  const lang = getCurrentLocaleCode();

  if (isExternalUrl(to)) {
    // Strip Remix-only props so they don't leak onto the native anchor
    const {
      viewTransition: _viewTransition,
      prefetch: _prefetch,
      reloadDocument: _reloadDocument,
      replace: _replace,
      state: _state,
      preventScrollReset: _preventScrollReset,
      relative: _relative,
      discover: _discover,
      ...anchorProps
    } = props;

    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
        {...anchorProps}
      >
        {props.children}
      </a>
    );
  }

  const localizedPath = `/${lang}${to}`;

  return (
    <RemixLink
      viewTransition
      to={localizedPath}
      type="canonical"
      className="block"
      {...props}
    >
      {props.children}
    </RemixLink>
  );
}
